import React, { useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import 'bootstrap/dist/css/bootstrap.min.css';
import styles from "./NavigationBar.module.css";
import { getCurrentUser } from 'aws-amplify/auth';

function NavigationBar() {
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    const checkAuthentication = async () => {
      try {
        await getCurrentUser();
        setIsAuthenticated(true); // User is authenticated
      } catch {
        setIsAuthenticated(false); // User is not authenticated
      }
    };

    checkAuthentication();
  }, []);

  return (
    <Navbar expand="lg">
      <Container className={styles["nav-container"]}>
        <Navbar.Brand href="/">
          <img className={styles["logo"]} src="/assets/images/logo.webp" alt="logo" />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />

        <Navbar.Collapse className={`justify-content-center ${styles["centered-navitem"]}`} id="basic-navbar-nav">
          <Nav className={styles["navitem-container"]}>
            <Nav.Link 
              className={styles["nav-item"]} 
              href="https://presagetechnologies.com/" 
              target="__blank" 
              rel="noopener noreferrer"
            >
              Home
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>

        {!isAuthenticated?
          <Navbar.Collapse className="justify-content-end" id="basic-navbar-nav">
            <Nav className={styles["navitem-container"]}>
              <Nav.Link className={styles["nav-item"]} href="/auth/login">Login</Nav.Link>
              <Nav.Link className={`${styles["nav-item"]} ${styles["register"]}`} href="/auth/register">
                Register
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
          :
          <Navbar.Collapse className="justify-content-end" id="basic-navbar-nav">
            <Nav className={styles["navitem-container"]}>
              <Nav.Link className={`${styles["nav-item"]} ${styles["register"]}`} href="/portal">User Portal</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        }
      </Container>
    </Navbar>
  );
}

export default NavigationBar;